import { Fragment } from "react";
import renderInline from "./renderInline";

const IMAGE_SIZES = {
  s: { maxWidth: 120, maxHeight: 80 },
  m: { maxWidth: 240, maxHeight: 140 },
  l: { maxWidth: 400, maxHeight: 200 }
};

export default function TextImageChoiceWidget({
  prompt,
  image,
  options = [],
  betweenImage,
  value,
  onChange,
  mode = "edit",
  size = "m",
  feedback
}) {
  // 🔑 CORRECT FEEDBACK SHAPE
  const part = feedback?.parts?.value;
  const showFeedback = Boolean(part);
  const expected = part?.expected;
  const received = part?.received;

  function select(v) {
    if (mode !== "edit" || showFeedback) return;
    onChange(v);
  }

  const hasStimulusImage = !!image;

  const optionsAreImageChoices =
    !hasStimulusImage &&
    Array.isArray(options) &&
    options.length > 0 &&
    typeof options[0] === "object" &&
    "value" in options[0] &&
    "src" in options[0];

  const imgSize = IMAGE_SIZES[size] ?? IMAGE_SIZES.m;

  return (
    <div>
      {/* Prompt */}
      <p style={{ fontWeight: 600, marginBottom: 8 }}>
        {Array.isArray(prompt)
          ? prompt.map((item, i) => renderInline(item, i))
          : prompt}
      </p>

      {/* Stimulus image */}
      {hasStimulusImage && (
        <div style={{ marginBottom: 16 }}>
          <img
            src={image}
            alt="Question"
            style={{
              maxWidth: imgSize.maxWidth,
              maxHeight: imgSize.maxHeight,
              display: "block"
            }}
          />
        </div>
      )}

      {/* Choices */}
      <div
        style={{
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >
        {optionsAreImageChoices
          ? options.map((opt, i) => {
              const isSelected = value === opt.value;

              // const isCorrect =
              //   showFeedback && opt.value === expected;

              // const isWrong =
              //   showFeedback &&
              //   isSelected &&
              //   opt.value !== expected;
              const isCorrect =
                showFeedback &&
                isSelected &&
                part?.correct === true;

              const isWrong =
                showFeedback &&
                isSelected &&
                part?.correct === false;

              return (
                <Fragment key={opt.value}>
                  <div
                    onClick={() => select(opt.value)}
                    style={{
                      cursor:
                        mode === "edit" && !showFeedback
                          ? "pointer"
                          : "default",
                      // border: isCorrect
                      //   ? "3px solid green"
                      //   : isWrong
                      //   ? "3px solid red"
                      //   : !showFeedback && isSelected
                      //   ? "3px solid black"
                      //   : "1px solid #ccc",
                      border: "3px solid",
                      borderColor: isCorrect
                        ? "#2e7d32"
                        : isWrong
                        ? "#c62828"
                        : !showFeedback && isSelected
                        ? "#000"
                        : "#ccc",
                      borderRadius: 8,
                      padding: 6,
                      background: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <img
                      src={opt.src}
                      alt={opt.value}
                      style={{
                        maxWidth: imgSize.maxWidth,
                        maxHeight: imgSize.maxHeight,
                        display: "block"
                      }}
                    />
                  </div>

                  {betweenImage && i < options.length - 1 && (
                    <img
                      src={betweenImage}
                      alt=""
                      style={{
                        maxWidth: imgSize.maxWidth,
                        maxHeight: imgSize.maxHeight,
                        opacity: 0.9,
                        pointerEvents: "none"
                      }}
                    />
                  )}
                </Fragment>
              );
            })
          : options.map((opt) => {
              const label =
                typeof opt === "string" ? opt : opt.value;

              const isSelected = value === label;

              // const isCorrect =
              //   showFeedback && label === expected;

              // const isWrong =
              //   showFeedback &&
              //   isSelected &&
              //   label !== expected;
              const isCorrect =
                showFeedback &&
                isSelected &&
                part?.correct === true;

              const isWrong =
                showFeedback &&
                isSelected &&
                part?.correct === false;

              return (
                <button
                  key={label}
                  onClick={() => select(label)}
                  disabled={mode !== "edit" || showFeedback}
                  style={{
                    minWidth: 48,
                    padding: "8px 16px",
                    fontSize: 16,
                    fontWeight: 600,
                    cursor:
                      mode === "edit" && !showFeedback
                        ? "pointer"
                        : "default",
                    borderRadius: 6,
                    border: "3px solid",
                    borderColor: isCorrect
                      ? "#2e7d32"
                      : isWrong
                      ? "#c62828"
                      : !showFeedback && isSelected
                      ? "#000"
                      : "#ccc",
                    background: "white"
                  }}
                >
                  {label}
                </button>
              );
            })}
      </div>
    </div>
  );
}
